import React from "react"
import { ITaskDocument } from "../../../models"
import YouTube, { Options } from 'react-youtube';
import moment from "moment"

interface IProps {
    task: ITaskDocument
    onCompleteTask(taskId: string): void
}

const TaskTypeYouTube: React.SFC<IProps> = (props: IProps) => {
    //https://www.npmjs.com/package/react-youtube
    const opts: Options = {
        height: '750',
        width: '1000',
        playerVars: {
            autoplay: 0,
        },
    }

    return (
        <div style={{ marginTop: 20 }}>
            {!props.task.Completed &&
                <div>{props.task.TaskType.TaskData2}</div>
            }
            {props.task.Completed &&
                <div>
                    Completed: {moment(props.task.CompletedDate).format("hh:mma MM/DD/YYYY")}
                </div>
            }
            <YouTube
                videoId={props.task.TaskType.TaskData1}
                opts={opts}
                onEnd={() => !props.task.Completed &&
                    props.onCompleteTask(props.task.Id)
                }
            />
        </div>
    )
}

export default TaskTypeYouTube